// extracted by mini-css-extract-plugin
export default {"wrapper":"n+54QcW","container":"jSaWcRC","title":"_5H-QDmA"};